module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDggMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0tOS4zMjUxZS0wNyAwLjMzMzY2TDAgMjEuNjY3TDIuNjY2NjcgMjEuNjY3TDIuNjY2NjcgMC4zMzM2NkwtOS4zMjUxZS0wNyAwLjMzMzY2Wk04IDIxLjY2N0w4IDAuMzMzNjZMNS4zMzMzMyAwLjMzMzY2TDUuMzMzMzMgMjEuNjY3TDggMjEuNjY3WiIgZmlsbD0iI0FGQUZBRSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_handle.svg
// module id = qD1+
// module chunks = 1